/**
 * Formats a Date object to a readable string format
 * @param date The date to format
 * @returns Formatted date string (YYYY-MM-DD)
 */
export const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

/**
 * Formats a date string to a more readable format
 * @param dateStr Date string in YYYY-MM-DD format
 * @returns Formatted date string (e.g., "10 March 2023")
 */
export const formatDateForDisplay = (dateStr: string): string => {
  const date = new Date(dateStr);
  return date.toLocaleDateString('sv-SE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

/**
 * Gets the next day's date
 * @param date Current date
 * @returns Next day's date
 */
export const getNextDay = (date: Date = new Date()): Date => {
  const nextDay = new Date(date);
  nextDay.setDate(nextDay.getDate() + 1);
  return nextDay;
};

/**
 * Checks if a time has passed for the current day
 * @param timeStr Time string in HH:MM format
 * @returns Boolean indicating if the time has passed
 */
export const hasTimePassed = (timeStr: string): boolean => {
  const now = new Date();
  const [hours, minutes] = timeStr.split(':').map(Number);
  
  const targetTime = new Date(now);
  targetTime.setHours(hours, minutes, 0, 0);
  
  return now > targetTime;
};